import { render } from "./MossDataMaterial.vue?vue&type=template&id=01468192"
import script from "./MossDataMaterial.vue?vue&type=script&lang=js"
export * from "./MossDataMaterial.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__